import type { ComponentProps } from 'react'
import { cn } from '../../lib/cn'
import { controlClass, useFieldControl } from './field'

/** A text of several lines in a Field, which gives it its label, hint and error. */
export function TextArea({ className, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(controlClass, 'min-h-24 resize-y', className)}
      {...useFieldControl()}
      {...props}
    />
  )
}
